import { Link } from "react-router-dom";

const SiteFooter = () => (
  <footer className="bg-hero text-primary-foreground">
    <div className="editorial-container section-padding">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <h3 className="font-serif text-xl font-semibold mb-4">Batts Legal LLP</h3>
          <p className="text-sm opacity-70 leading-relaxed">
            Strategic antitrust counsel for complex corporate matters. Advising corporations, investors, and industry leaders on competition law and policy.
          </p>
        </div>
        <div>
          <h4 className="font-sans text-xs font-semibold uppercase tracking-widest mb-4 opacity-60">Practice Areas</h4>
          <div className="space-y-2.5">
            {["Merger & Transaction Antitrust", "Government Investigations", "Antitrust Litigation", "Antitrust Counseling", "Consumer Protection"].map((item) => (
              <Link key={item} to="/practice-areas" className="block text-sm opacity-70 hover:opacity-100 transition-opacity">{item}</Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-sans text-xs font-semibold uppercase tracking-widest mb-4 opacity-60">Intelligence</h4>
          <div className="space-y-2.5">
            {[
              { name: "Policy Intelligence", href: "/intelligence" },
              { name: "Merger Risk Radar", href: "/merger-risk-radar" },
              { name: "Enforcement Index", href: "/enforcement-index" },
              { name: "Strategy Briefings", href: "/strategy-briefings" },
              { name: "Market Structure", href: "/market-structure" },
            ].map((item) => (
              <Link key={item.name} to={item.href} className="block text-sm opacity-70 hover:opacity-100 transition-opacity">{item.name}</Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-sans text-xs font-semibold uppercase tracking-widest mb-4 opacity-60">Contact</h4>
          <div className="space-y-2.5 text-sm opacity-70">
            <p>Washington, D.C.</p>
            <p>info@battslegal.com</p>
          </div>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs opacity-50">© {new Date().getFullYear()} Batts Legal LLP. All rights reserved.</p>
        <div className="flex gap-6">
          <span className="text-xs opacity-50">Attorney Advertising</span>
          <Link to="/contact" className="text-xs opacity-50 hover:opacity-80 transition-opacity">Privacy Policy</Link>
          <Link to="/contact" className="text-xs opacity-50 hover:opacity-80 transition-opacity">Terms</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
